"use strict";

import angular from "angular";

import template from "./empty-message-default.component.html";
import "./themes/empty-message-default.scss";
import "./themes/empty-message-default-dark.scss";

class EmptyMessageDefaultComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

EmptyMessageDefaultComponent.$inject = [];

const name = "emptyMessageDefaultComponent";
const def = {
    bindings: {
        image: "@",
        message: "@",
        description: "@",
        buttonProps: "<",
        buttonAction: "&"
    },
    controller: EmptyMessageDefaultComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
